import { createContext, useContext, useState, useEffect } from 'react';

const PreferencesContext = createContext(null);

const DEFAULTS = {
  fontSize: 'md',               // sm | md | lg | xl
  bgTheme: 'zinc',              // zinc | slate | stone | sky | warm
  printerIp: '',
  printerPort: '9100',
  printerEnabled: false,
  bridgeUrl: 'http://localhost:3333',  // URL del puente local
};

function load() {
  try {
    const raw = localStorage.getItem('pos_prefs');
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch {
    return { ...DEFAULTS };
  }
}

function applyToDOM(prefs) {
  const root = document.documentElement;
  root.setAttribute('data-fontsize', prefs.fontSize);
  root.setAttribute('data-bg', prefs.bgTheme);
}

export function PreferencesProvider({ children }) {
  const [prefs, setPrefs] = useState(() => {
    const p = load();
    applyToDOM(p);
    return p;
  });

  const update = (patch) => {
    setPrefs(prev => {
      const next = { ...prev, ...patch };
      localStorage.setItem('pos_prefs', JSON.stringify(next));
      applyToDOM(next);
      return next;
    });
  };

  return (
    <PreferencesContext.Provider value={{ prefs, update }}>
      {children}
    </PreferencesContext.Provider>
  );
}

export function usePreferences() {
  const ctx = useContext(PreferencesContext);
  if (!ctx) throw new Error('usePreferences must be used within PreferencesProvider');
  return ctx;
}
